import { WebsiteVisitorTrackingRoot, UnsafeScreenRoot } from "types";

export const WebsiteVisitorTrackingRootDefinition: UnsafeScreenRoot = {
  name: WebsiteVisitorTrackingRoot,
  routePath: ["/website-visitor-tracking/*"],
};
